<template>
<FormRow inline v-if="pledge && pledge.cardsOnFile.length > 0">
  <FormCol field="token" :showLabel="false">
    <FormSelect>
      <option :value="null">Choose a card on file</option>
      <option v-for="card of pledge.cardsOnFile" :key="card.token" :value="card.token">{{card.card}}</option>
    </FormSelect>
  </FormCol>
</FormRow>
</template>
<script setup lang="ts">
defineProps<{
  pledge?: any
}>()
</script>